export default __webpack_public_path__ + "static/media/F1_1.5750d9a8.png";